import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from './utils/theme';
import { Provider } from 'react-redux';
import store from './store';
import { Slide, ToastContainer as OriginalToastContainer } from 'react-toastify';
import { ErrorBoundary } from './components/ErrorBoundary';

const ToastContainer = styled(OriginalToastContainer)`
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <ErrorBoundary>
    <Provider store={store}>
      <App />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Slide}
        
      />
    </Provider>
    </ErrorBoundary>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
